<template>
  <div id="app">
    <div class="bg-helper" />
    <ffg-header v-show="$route.name !== 'patch'" id="header" />
    <main>
      <router-view />
    </main>
  </div>
</template>

<style lang="scss">
@import "assets/_variables.scss";
@import url("https://fonts.googleapis.com/css2?family=Space+Mono:wght@400;700&display=swap");

html,
body {
  font-family: "Space Mono", sans-serif;
  --background: url("assets/bg-light.jpg");

  width: 100vw;
  min-height: 100vh;

  overflow-x: hidden;

  margin: 0;
  padding: 0;

  display: flex;
  flex-direction: column;

  color: $foreground;
}

.bg-helper {
  position: fixed;
  top: 0;
  left: 0;
  min-width: 100vw;
  min-height: 100vh;

  background-image: var(--background);
  background-size: cover;
  background-position: center;
}

h1 {
  margin-top: 0;
  font-size: 48px;
}

h2 {
  font-size: 26px;
}

h3 {
  font-size: 20px;
}

@media screen and (max-width: 600px) {
  h1 {
    font-size: 40px;
  }

  h2 {
    font-size: 20px;
  }

  h3 {
    font-size: 20px;
  }
}

#app {
  height: 100%;

  flex-grow: 1;
  padding: 2rem;
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 1200px) {
  #app {
    padding: 1rem;
  }
}

main {
  color: black;
  position: relative;
  padding: 2rem 12rem;
  flex-grow: 1;

  & > div {
    width: 100%;
  }
}

@media screen and (max-width: 1200px) {
  main {
    padding: 2rem 4rem;
  }
}

@media screen and (max-width: 600px) {
  main {
    padding: 0 0.5rem;
  }

  h1,
  h2 {
    text-align: center;
  }
}

.button {
  display: inline-block;
  cursor: pointer;
  color: $foreground;
  background: $background-tertiary;
  border-radius: $border-radius;
  text-shadow: none;
  text-decoration: none;
  padding: 0.5em 2em;
  text-align: center;
}

.button:active,
.button.router-link-active {
  background: $background-secondary !important;
  // border: 1px solid $foreground-negative;
}

.slim-button {
  padding: 0.1em 0.5em;
}
</style>
<script>
import FfgHeader from "@/components/FfgHeader";

export default {
  components: { FfgHeader },
};
</script>
